import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, Nav } from 'react-bootstrap';

import MainContext from '../../contexts/MainContext';
import { STARSTAKE_BRANDCLUB_URL } from '../../config';

import { ReactComponent as TraningIcon } from '../../img/svg/Assets/CapBlue.svg';
import { ReactComponent as MintingGuildlinesIcon } from '../../img/svg/Assets/FileBlue.svg';
import { ReactComponent as MarketHubIcon } from '../../img/svg/Header/MarketHub.svg';
import { ReactComponent as Speaker } from '../../img/svg/Assets/Speaker.svg';
import { ReactComponent as RedeemCertAnftIcon } from '../../img/svg/DropDown/redeem-certificate-anft.svg';
import { ReactComponent as SLetterBlue } from '../../img/svg/Logos/SLetterBlue.svg';
import { ReactComponent as Access } from '../../img/svg/DropDown/Access.svg';
import { ReactComponent as BrandClub } from '../../img/svg/DropDown/BrandClub.svg';
import { ReactComponent as Bucks } from '../../img/svg/DropDown/Bucks.svg';
import { ReactComponent as DiscoverStars } from '../../img/svg/DropDown/DiscoverStars.svg';
import { ReactComponent as Info } from '../../img/svg/DropDown/Info.svg';
import { ReactComponent as Message } from '../../img/svg/DropDown/Message.svg';
import { ReactComponent as Shop } from '../../img/svg/DropDown/shop.svg';
import { ReactComponent as StakeHub } from '../../img/svg/DropDown/StakeHub.svg';
import { ReactComponent as StarSTKR } from '../../img/svg/DropDown/StarSTKR.svg';
import { ReactComponent as CreatorHub } from '../../img/svg/DropDown/CreatorHub.svg';
import { ReactComponent as StarHub } from '../../img/svg/DropDown/StarHub.svg';

const marketplaceData = [
  {
    title: 'Discover',
    description: 'Discover what’s hot',
    icon: <MarketHubIcon />,
    link: '/MarketHub'
  },
  {
    customClass: 'customStrokeSvg',
    title: 'Campaign Club',
    description: 'Rewards, status, access & more',
    icon: <BrandClub />,
    link: '/MarketHub/BrandClubMarket'
  },
  {
    customClass: 'customStrokeSvg',
    title: 'RWA Bucks ',
    description: 'Currency of the Brands',
    icon: <Bucks />,
    link: '/MarketHub/NFTBucksMarket'
  },
  {
    customClass: 'customStrokeSvg',
    title: 'Certificates',
    description: 'Access to goods & services',
    icon: <Access />,
    link: '/MarketHub/AccessNFTMarket'
  },
  {
    customClass: 'customStrokeSvg',
    title: 'Discover Brands',
    description: 'View Brands',
    icon: <DiscoverStars />,
    link: '/MarketHub/DiscoverStars'
  }
];
const exploreData = [
  {
    title: 'BrandHub',
    description: 'How RealWorldFunding works for Brands',
    icon: <CreatorHub />,
    link: '/ForCreators',
    protectedRoute: '/CreatorHub'
  },
  {
    title: 'StakeHub',
    description: 'How RealWorldFunding works for Backers',
    icon: <StakeHub />,
    link: '/ForFans',
    protectedRoute: '/StakeHub'
  },
  // {
  //   customClass: 'customStrokeSvg',
  //   title: 'About Us',
  //   description: 'The team behind StarStake',
  //   icon: <Info />,
  //   link: '/AboutUs'
  // },
  // {
  //   title: '# Real World Funders',
  //   description: 'Our Movement',
  //   icon: <StarSTKR />,
  //   link: '/ComingSoon'
  // },
  // {
  //   title: 'Real World Campaign Club',
  //   description: 'Join Us',
  //   icon: <SLetterBlue />,
  //   link: STARSTAKE_BRANDCLUB_URL
  // },
  // {
  //   customClass: 'customStrokeSvg',
  //   title: 'Shop',
  //   description: 'Check out our merch',
  //   icon: <Shop />,
  //   link: '/ComingSoon'
  // }
];
const resourcesData = [
  {
    customClass: 'customStrokeSvg',
    title: 'Help Center',
    description: "We're here to help",
    icon: <Message />,
    link: 'https://intercom.help/starstake'
  },
  {
    title: 'Redeem Access Certificate',
    description: 'Enter your access code here',
    icon: <RedeemCertAnftIcon />,
    link: '/ForFans',
    protectedRoute: '/StakeHub/AccessNFT?redeem=true'
  },
  {
    title: 'Community Guidelines',
    description: 'Our backer / brand guidelines',
    icon: <MintingGuildlinesIcon />,
    link: '/StarStakeGuidelines'
  },
  // {
  //   title: 'Latest News',
  //   description: 'What’s going on',
  //   icon: <Speaker />,
  //   link: 'https://www.instagram.com/star_stake/'
  // },
  // {
  //   title: 'Training Center',
  //   description: 'Learn how to use StarStake',
  //   icon: <TraningIcon />,
  //   link: '/ForFans',
  //   protectedRoute: '/StakeHub/TrainingCenter'
  // },
  // {
  //   customClass: 'communityIcon',
  //   title: 'Community',
  //   description: 'Join us on StarHub',
  //   icon: <StarHub />,
  //   link: 'https://starhub.starstake.com/'
  // }
];
const dropdownData = [
  {
    title: 'Discover',
    description: 'THE REAL WORLD FUNDING MARKETPLACE',
    data: marketplaceData
  },
  {
    title: 'Explore',
    description: 'DISCOVER REAL WORLD FUNDING',
    data: exploreData
  },
  {
    title: 'Resources',
    description: 'GET WHAT YOU NEED',
    data: resourcesData
  }
];

const DropdownItem = ({ item = {} }) => {
  const { isRegistered = false, hasCreatorAccess = false } =
    React.useContext(MainContext);

  return (
    <Nav.Link
      eventKey={item.title}
      as={item.link.includes('http') ? 'a' : Link}
      to={
        item.protectedRoute && isRegistered
          ? item.protectedRoute !== '/CreatorHub' || hasCreatorAccess
            ? item.protectedRoute
            : item.link
          : item.link
      }
      href={item.link}
      target={item.link.includes('http') ? '_blank' : '_self'}
    >
      <div className="d-flex">
        <div className={item.customClass ? item?.customClass : 'filled-Svg'}>
          {item.icon}
        </div>
        <div className="ps-3">
          <div className="dropdown-item-title">{item.title}</div>
          <div className="dropdown-text">{item.description}</div>
        </div>
      </div>
    </Nav.Link>
  );
};

const DropdownContainer = ({ dropdown }) => {
  const [show, setShow] = useState(false);
  const showDropdown = () => setShow(true);
  const hideDropdown = () => setShow(false);

  return (
    <Dropdown
      show={show}
      onMouseEnter={showDropdown}
      onMouseLeave={hideDropdown}
      className="py-0 select-dropdown"
    >
      <Dropdown.Toggle
        className="px-0 py-2 btn"
        variant=""
        id="select-dropdown"
      >
        {dropdown.title}
      </Dropdown.Toggle>
      <Dropdown.Menu onClick={() => hideDropdown()} className="dropdown-menu">
        <div className="dropdown-title">{dropdown.description}</div>
        {dropdown.data.map((item, index) => (
          <DropdownItem item={item} key={index} />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

const Dropdowns = () => {
  return (
    <div className="drop-down-wrapper">
      {dropdownData.map((dropdown, index) => (
        <div key={index}>
          <DropdownContainer key={`dropdown-${index}`} dropdown={dropdown} />
        </div>
      ))}
    </div>
  );
};

export default Dropdowns;
